import request from "~/utils/http";

export function signInByMobile(data) {
  return request({
    url: "api/User/SignInByMobile",
    method: "post",
    data
  });
}

export function SignInBySms(data) {
  return request({
    url: "api/User/SignInBySms",
    method: "post",
    data
  });
}

export function SendLoginSms(data) {
  return request({
    url: "api/FrontUser/SendLoginSms",
    method: "post",
    data
  });
}

export function sendRegisterSms(data) {
  return request({
    url: "api/FrontUser/SendRegisterSms",
    method: "post",
    data
  });
}

export function signUp(data) {
  return request({
    url: "api/User/SignUp",
    method: "post",
    data
  });
}

export function getCurrent() {
  return request({
    url: "api/User/GetCurrent",
    method: "post",
    data: {}
  });
}

export function signOut() {
  return request({
    url: "api/User/SignOut",
    method: "post",
    data: {}
  });
}

export function bindWeChat(data) {
  return request({
    url: "api/WeChatUserJoinRequest/Bind",
    method: "post",
    data
  });
}

export function getWeChat(data) {
  return request({
    url: "api/WeChatUserJoinRequest/Get",
    method: "post",
    data: data
  });
}

export const getReferenceInfo = () =>
  request({
    url: "api/User/GetReferenceInfo",
    method: "get"
  });
